function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import StyledHr from "./hr.style";
import useIsAboveBreakpoint from "../../hooks/__internal__/useIsAboveBreakpoint";
const Hr = ({
  adaptiveMxBreakpoint,
  ml,
  mr,
  ...rest
}) => {
  const largeScreen = useIsAboveBreakpoint(adaptiveMxBreakpoint);
  let marginLeft = ml;
  let marginRight = mr;
  if (adaptiveMxBreakpoint && !largeScreen) {
    marginLeft = 0;
    marginRight = 0;
  }
  return /*#__PURE__*/React.createElement(StyledHr, _extends({
    "data-component": "hr",
    ml: marginLeft,
    mr: marginRight,
    mt: rest.mt || 3,
    mb: rest.mb || 3
  }, rest));
};
Hr.propTypes = {
  "adaptiveMxBreakpoint": PropTypes.number,
  "m": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "margin": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginBottom": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginLeft": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginRight": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginTop": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginX": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginY": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mb": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "ml": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mr": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mt": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mx": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "my": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])
};
export { Hr };
export default Hr;